import { useSyncExternalStore } from 'react';

// Whether the knowledge map (ORA-867) is showing on the active desktop. The
// desktop owns the map; the shell, in another subtree, reads this to stand
// its floating chrome (exam selector, bell, theme toggle, Open Dashboard)
// aside while the map has the whole screen.
let isOpen = false;
const listeners = new Set<() => void>();
const getIsKnowledgeMapOpen = (): boolean => isOpen;

const subscribeKnowledgeMapOpen = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const setKnowledgeMapOpen = (next: boolean): void => {
  if (isOpen === next) return;
  isOpen = next;
  listeners.forEach((listener) => listener());
};

export const useIsKnowledgeMapOpen = (): boolean =>
  useSyncExternalStore(
    subscribeKnowledgeMapOpen,
    getIsKnowledgeMapOpen,
    getIsKnowledgeMapOpen
  );

/** Back to closed (tests). */
export const resetKnowledgeMapOpen = (): void => setKnowledgeMapOpen(false);

// A close the desktop is asked for from outside (the nav's Home item while
// the map has the desktop): the desktop registers its closer while mounted.
let closer: (() => void) | null = null;

export const registerKnowledgeMapCloser = (next: () => void): (() => void) => {
  closer = next;
  return () => {
    if (closer === next) closer = null;
  };
};

/** Closes the map if it is open; a no-op otherwise. */
export const requestKnowledgeMapClose = (): void => {
  if (isOpen) closer?.();
};
